import { render, staticRenderFns } from "./queryWarnStock.vue?vue&type=template&id=0505d59c&scoped=true"
import script from "./queryWarnStock.vue?vue&type=script&lang=js"
export * from "./queryWarnStock.vue?vue&type=script&lang=js"
import style0 from "./queryWarnStock.vue?vue&type=style&index=0&id=0505d59c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0505d59c",
  null
  
)

export default component.exports